/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Grid,
  GridItem,
  Spinner,
} from '@chakra-ui/react';
import { useContext, useEffect } from 'react';
import AppColors from '../../../constants/AppColors';
import { withProvider } from '../../../hoc/withProvider';
import MyAccountProvider, {
  MyAccountContext,
} from '../../../providers/MyAccountProvider';
import { CommonMyAccountComponents } from './CommonMyAccountComponents';
import DepartmentMyAccount from './DepartmentMyAccount';
import ErrorComponent from './ErrorComponent';
import HealthSystemMyAccount from './HealthSystemMyAccount';
import HospitalMyAccount from './HospitalMyAccount';
import PhysicianGroupMyAccount from './PhysicianGroupMyAccount';
import ProviderMyAccount from './ProviderMyAccount';
import { getCurrentClientType, ClientType } from '../../../utils/clientTypeUtils';
import { AuthContext } from '../../../providers/AuthProvider';
import { add, isAfter } from 'date-fns';
import useDeviceScreen from '../../../hooks/useDeviceScreen';

const GridItemWrapper = ({children }) => {
      return (
        <Box 
          w={'100%'} 
          mt={1}
          p={3}
          justifyContent={'space-between'}
          m={'auto'}
          my={5}
          fontSize={'xl'}
          bgColor={AppColors.white}
          borderRadius={'lg'}
          boxShadow={'md'}>
  
            {children}
        </Box>
  
      );
    };

const MyAccountsWrapper = () => {
  const myAccountContext = useContext(MyAccountContext);
  const authContext = useContext(AuthContext);
  const currentUser = myAccountContext.currentUserType;

  useEffect(() => {
    myAccountContext.userTypeLookup();
  }, []);
  
  useEffect(() => {
    if (myAccountContext?.currentUserType) {
      myAccountContext.changeDashboardView(authContext.currentUser.user_type);
    }
  }, [myAccountContext.isGettingUserType])

  useEffect(() => {
    let type;
    if ((type = authContext?.currentUser?.user_type) && myAccountContext.currentUserType) {
      myAccountContext.changeDashboardView(type);
    }
  }, [authContext?.currentUser?.user_type]);


  const getData = async(formData, isAccountContactChanged) => {
    const userNames = {
      first_name: myAccountContext.currentUserType.first_name,
      last_name: myAccountContext.currentUserType.last_name,
    };
    let updatedBody = {...formData , my_account_update_flag: true};

    if (isAccountContactChanged) {
      updatedBody = {
        ...userNames,
        ...updatedBody,
        account_contact: formData.account_contact,
      };
    } else {
      updatedBody = {
        ...userNames,
        ...updatedBody,
        account_contact: currentUser.account_contact,
      };
    }
  await myAccountContext.editUserData(updatedBody);
  };

  const handleImageSubmit = async (key, selectedImage, CLIENT_TYPE_KEY) => {
    // Handle the submission of the image (e.g., send it to a server)
    const response =  await myAccountContext.editUserTypeLogo(key, selectedImage, CLIENT_TYPE_KEY);
    
    authContext.setCurrentUser((prev)=>({...prev,
      [CLIENT_TYPE_KEY]: {
        ...prev[CLIENT_TYPE_KEY], 
        [key]: response[key]
      }}
    ));

  };
  
  const renderComponentByUser = () => {
    const userType = getCurrentClientType(currentUser.type);
    switch (userType) {
      case ClientType.HEALTH_SYSTEM:
        return <HealthSystemMyAccount 
        getData={getData} 
        GridItemWrapper={GridItemWrapper}
        handleImageSubmit={handleImageSubmit}
        />;
      case ClientType.HOSPITAL:
        return <HospitalMyAccount 
        getData={getData} 
        GridItemWrapper={GridItemWrapper}
        handleImageSubmit={handleImageSubmit}
        />;
      case ClientType.DEPARTMENT:
        return <DepartmentMyAccount 
        getData={getData} />;
      case ClientType.PHYSICIANS_GROUP:
        return <PhysicianGroupMyAccount 
        getData={getData} 
        GridItemWrapper={GridItemWrapper}
        handleImageSubmit={handleImageSubmit}
        />;
      case ClientType.PROVIDER:
        return <ProviderMyAccount 
        getData={getData} />;

      default:
        return <ErrorComponent />;
    }
  };

  const shouldShowWelcomeWalkthrough = () => {
    if (!authContext.currentUser?.created_date) return false;
  
    const dateToCompare = add(new Date(authContext.currentUser.created_date), {
      days: 90,
    });
  
    return isAfter(new Date(), dateToCompare);
  };

  const { isWeb } = useDeviceScreen();
  

  const version2 = () => {
    return (
      <Box width={'100%'} mb={4} p={5} borderRadius={'lg'} mt={-6}>
          <Grid
            width="75%"
            m="auto"
            templateColumns={{
              base: '1fr',         // Mobile: 1 column
              md: '1fr',           // Medium: 1 column
              lg: '50% 50%'        // Large: 2 columns with 30%-70% width split
            }}
            gap={10}
            fontSize="xl"
          >
            <GridItem>
              <CommonMyAccountComponents
              getData={getData}
              GridItemWrapper={GridItemWrapper}
              />
              </GridItem>

              {/* right side */}
              <GridItem>
                <Box width={'100%'} mb={4} p={5} borderRadius={'lg'}>
                  {renderComponentByUser()}              
              </Box>
              </GridItem>
            </Grid>
                  </Box>

    )
  }

  return (
    <>
      {myAccountContext.currentUserType !== null ? (    
        version2()  
        // <SimpleGrid
        //   width={'70%'}
        //   m={'auto'}
        //   my={4}
        //   columns={{ sm: 1, md: 1, lg: 1 }}
        //   spacing={10}
        //   fontSize={'xl'}
        // >
        //   <GridItem mb={'15%'}>
        //     <FormLabel
        //       fontFamily={FONT_FAMILY.baiJamurjee}
        //       fontWeight={'bold'}
        //       fontSize={'2xl'}
        //       color={AppColors.black}
        //     >
        //       My Account
        //     </FormLabel>
        //     <CommonMyAccountComponents
        //       getData={getData}
        //     />
        //     {renderComponentByUser()}
        //     {/* Welcome Walkthrough Button */}
        //     {shouldShowWelcomeWalkthrough() && (
        //       <Box
        //         bgColor={AppColors.white}
        //         borderRadius={'lg'}
        //         boxShadow={'md'}
        //         width="30%"
        //         p={4}
        //         mt={4}
        //       >
        //         <Button
        //           bg={AppColors.secondary}
        //           color="white"
        //           _hover={{ bg: AppColors.modalOverlayColor }}
        //           width="100%"
        //           fontSize="lg"
        //           fontWeight="bold"
        //           onClick={() => {
        //             navigate(ROUTES.DASHBOARD);
        //             setTimeout(() => {
        //               authContext.setRunTour(true);
        //             }, 500);
        //           }}
        //         >
        //           Welcome Walkthrough
        //         </Button>
        //       </Box>
        //     )}
        // </GridItem>
        // </SimpleGrid>
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default withProvider(MyAccountProvider, MyAccountsWrapper);
